import React from "react";
import { observer } from "mobx-react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import mlbLogo from "images/mlb.png";
import milbLogo from "images/milb.png";
import { CMS_DESTINATION } from "../utils/constants";

const DESTINATION_META = {
  [CMS_DESTINATION.MLB]: { label: "Forge MLB", logo: mlbLogo },
  [CMS_DESTINATION.MILB]: { label: "Forge MiLB", logo: milbLogo }
};


const IDLE_BORDER_COLOR = "rgba(0, 0, 0, 0.23)";
const ERROR_COLOR = "#f44336";

const DestinationLabel = ({ src, label }) => (
  <span style={{ display: "flex", alignItems: "center", gap: "7px" }}>
    <img src={src} alt={label} style={{ height: "16px", display: "block" }} />
    {label}
  </span>
);

class ForgeDestinationCheckboxes extends React.Component {
  render() {
    const { store } = this.props;

    if (store.availableDestinations.length <= 1) {
      return null;
    }

    const isValid = store.hasValidDestinationSelection;

    return (
        <FormControl
            component="fieldset"
            required
            error={!isValid}
            focused={false}
            style={{
              border: `1px solid ${isValid ? IDLE_BORDER_COLOR : ERROR_COLOR}`,
              borderRadius: "4px",
              padding: "0 8px 4px"
            }}
        >
          <FormLabel
              component="legend"
              style={{ fontSize: "0.75rem", padding: "0 4px" }}
          >
            Send To
          </FormLabel>
          <FormGroup>
            {store.availableDestinations.map(destination => (
                <FormControlLabel
                    key={destination}
                    control={
                      <Checkbox
                          color="primary"
                          checked={store.isDestinationSelected(destination)}
                          onChange={() => store.toggleDestination(destination)}
                      />
                    }
                    label={
                      <DestinationLabel
                          src={DESTINATION_META[destination].logo}
                          label={DESTINATION_META[destination].label}
                      />
                    }
                />
            ))}
          </FormGroup>
        </FormControl>
    );
  }
}

export default observer(ForgeDestinationCheckboxes);



// WEBPACK FOOTER //
// ./src/components/ForgeDestinationCheckboxes.js